import { GlobalBookingTripDates } from '@fcom/common';
import { GlobalBookingTravelClass, TripType } from '@fcom/core';
import { PaxAmount } from '@fcom/dapi';
import { LocationPair } from '@fcom/common/store';

export enum WidgetTab {
  FLIGHT = 'flight',
  AWARD = 'award',
  AM = 'aurinkomatkat',
}

export interface FlightSearchParams {
  locations: LocationPair[];
  paxAmount: PaxAmount;
  travelClass: GlobalBookingTravelClass;
  travelDates: GlobalBookingTripDates;
  tripType: TripType;
  locale?: string;
  activatedTab?: WidgetTab;
  promoCode?: string | null;
  isAward?: boolean;
}

export interface InstantSearchBaseParams {
  departureLocationCode: string;
  destinationLocationCode: string;
  numberOfDays: number;
  travelClass?: string;
  oneway?: boolean;
  adults?: number;
  children?: number;
  infants?: number;
  directFlights?: boolean;
  isCountryShopTestGroup?: boolean;
  locale?: string;
}

export interface InstantSearchFullYearParams extends InstantSearchBaseParams {
  startDate: string;
}

export interface InstantSearchFollowingMonthParams extends InstantSearchBaseParams {
  departureDate: string;
}
